import { Confirmation, Success } from './components';

const CloseAllPositionsFlow = {
  Confirmation,
  Success,
};

export { CloseAllPositionsFlow };
